export default __webpack_public_path__ + "static/messenger-7f33453106e96408724b9367bee2dce9.png";